module.exports = __webpack_public_path__ + "img/Candella_1_small.995ebc80.jpg";